import { beneficiaryAccountType, counterpartInstitution } from "../../const/transference.cost";

export function getAccountTypeDescription(key: string): string {
  const found = beneficiaryAccountType.find((type) => type.key === key);
  return found ? found.description : "Desconocido"; // Retorna 'Desconocido' o un valor por defecto si no se encuentra
}

export function getBank(key: string): string {
  const found = counterpartInstitution.find((type) => type.key === key);
  return found ? found.participant : "Desconocido"; // Retorna 'Desconocido' o un valor por defecto si no se encuentra
}
